import { createSearchAssetFilter } from '../../factories';
import { phoenixConfig } from '../../network';
import { KalturaMediaAsset } from '../../objects';
import { fetchAssetList, fetchCategoryTreeById, fetchCategoryTreeByVersion } from '../../services';

type FetchCategoryTreeArgs = {
  /**
   * Category ID. If this parameter is provided, the tree will be loaded based on this ID.
   * Otherwise, a production tree for a specific device type will be loaded.
   */
  categoryId?: number;
};
export function fetchCategoryTree({ categoryId }: FetchCategoryTreeArgs) {
  if (categoryId) {
    return fetchCategoryTreeById({ categoryItemId: categoryId });
  }
  return fetchCategoryTreeByVersion({ deviceFamilyId: phoenixConfig.deviceFamilyId });
}

export function fetchUidas(assetIds: number[]) {
  return fetchAssetList<KalturaMediaAsset>({
    filter: createSearchAssetFilter({
      kSql: `(and (or ${assetIds.map((id) => `CategoryId = '${id}' `).join('')})(or ))`,
    }),
    allPages: true,
  });
}
